import _ from 'lodash';

const getFlightSegmentsExcludingHiddenStops = (flightItinerary) => {
  try {
    let allFlights = [];

    if (flightItinerary && flightItinerary.flightSegments) {
      allFlights = _.flatMap(flightItinerary.flightSegments, (segment) => segment.flights || []);
    }

    const flights = {};
    let segmentNumber = -1;

    for (let index = 0; index < allFlights.length; index += 1) {
      const flightSeg = {
        flightNumber: allFlights[index].flightNumber,
        carrierCode: allFlights[index].carrierCode,
        originAirportCode: allFlights[index].originAirportCode,
        destinationAirportCode: allFlights[index].destinationAirportCode,
        departDateTime: allFlights[index].departDateTime,
        segmentNumber,
        flight: allFlights[index],
      };

      if (
        flights[segmentNumber] &&
        flights[segmentNumber].length &&
        _.last(flights[segmentNumber]).flightNumber === allFlights[index].flightNumber &&
        _.last(flights[segmentNumber]).carrierCode === allFlights[index].carrierCode
      ) {
        if (!flights[segmentNumber]) flights[segmentNumber] = [];
        flights[segmentNumber].push(flightSeg);
      } else {
        segmentNumber += 1;
        if (!flights[segmentNumber]) flights[segmentNumber] = [];
        flightSeg.segmentNumber = segmentNumber;
        flights[segmentNumber].push(flightSeg);
      }
    }

    return flights;
  } catch (ex) {
    return undefined;
  }
};

export default getFlightSegmentsExcludingHiddenStops;
